export default __webpack_public_path__ + "static/media/spinner-blue.04e8415a.gif";